
export { ArrowLeft } from "/vercel/path0/packages/icons/ui/controls-a-l.ts"
export { ArrowRight } from "/vercel/path0/packages/icons/ui/controls-a-l.ts"